import type { TFunction } from "i18next";

import { DefaultEmptyData } from "@/types/staticStrings";

import type { AccessAction, GetUserRoleDisplayedName } from "./types";

export const getUserRoleDisplayedName: GetUserRoleDisplayedName = ({
  code,
  name,
  t,
}) => {
  // system profile role
  if (code) {
    return t(`profiles.codes.${code}`);
  }

  // custom profile role
  if (name) {
    return name;
  }

  return DefaultEmptyData.Dash;
};

interface SelectionPanelLabels {
  title: string;
  subtitle: string;
  confirmLabel: string;
  resetLabel: string;
  exitLabel: string;
  selectedLabel: (count: number) => string;
  minLimitLabel: (min: number) => string;
  maxLimitLabel: (max: number) => string;
  errorAriaLabel: string;
}

interface UserCompaniesFilters {
  showEnabledUsers: boolean | undefined;
  showDisabledUsers: boolean | undefined;
}

export function getUserCompaniesFiltersFromAccessAction(
  accessAction: AccessAction | "",
): UserCompaniesFilters {
  switch (accessAction) {
    case "enable":
      return { showEnabledUsers: false, showDisabledUsers: true };
    case "disable":
      return { showEnabledUsers: true, showDisabledUsers: false };
    default:
      return { showEnabledUsers: undefined, showDisabledUsers: undefined };
  }
}

export function getSelectionPanelTranslations(
  tUsers: TFunction,
  tCommon: TFunction,
  accessAction: AccessAction
): SelectionPanelLabels {
  const baseKey = `list.accessManagement.bulkOperations.${accessAction}`;

  return {
    title: tUsers(`${baseKey}.title`),
    subtitle: tUsers(`${baseKey}.subtitle`),
    confirmLabel: tCommon("bulkOperations.selection.confirm"),
    resetLabel: tCommon("bulkOperations.selection.reset"),
    exitLabel: tCommon("bulkOperations.selection.exit"),
    selectedLabel: (count: number) =>
      tCommon("bulkOperations.selection.selected", { count }),
    minLimitLabel: (min: number) =>
      tCommon("bulkOperations.selection.limit.min", { min }),
    maxLimitLabel: (max: number) =>
      tCommon("bulkOperations.selection.limit.max", { max }),
    errorAriaLabel: tCommon("bulkOperations.selection.error"),
  };
}
